/* unplugin-vue-components disabled */import { render } from "./VeevaAISpeachLoader.vue?vue&type=template&id=69e89c2c&scoped=true&ts=true"
import script from "./VeevaAISpeachLoader.vue?vue&type=script&lang=ts"
export * from "./VeevaAISpeachLoader.vue?vue&type=script&lang=ts"

import "./VeevaAISpeachLoader.vue?vue&type=style&index=0&id=69e89c2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e89c2c"]])

export default __exports__